import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/appIcon';

const CompanyBranding = () => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="text-center space-y-8"
    >
      {/* Enhanced Company Logo */}
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.6, type: "spring", stiffness: 200 }}
        className="flex items-center justify-center"
      >
        <div className="relative">
          <div className="flex items-center justify-center w-24 h-24 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-2xl shadow-2xl relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
            <Icon name="Zap" size={48} color="white" strokeWidth={2.5} />
          </div>
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            className="absolute -inset-2 border-2 border-cyan-400/30 rounded-2xl"
          ></motion.div>
          <div className="absolute -bottom-1 -right-1 w-7 h-7 bg-gradient-to-br from-green-400 to-green-500 rounded-full flex items-center justify-center shadow-lg">
            <Icon name="CheckCircle" size={16} color="white" strokeWidth={2} />
          </div>
        </div>
      </motion.div>

      {/* Company Name and Tagline */}
      <div className="space-y-3">
        <motion.h1
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-4xl font-bold bg-gradient-to-r from-cyan-300 to-blue-400 bg-clip-text text-transparent"
        >
          ElektronikPro
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-xl text-cyan-200 font-medium"
        >
          Truck Electronics
        </motion.p>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="flex items-center justify-center space-x-2 text-sm text-cyan-300"
        >
          <Icon name="Shield" size={18} className="text-cyan-400" />
          <span>Sistema de Gestión Empresarial Seguro</span>
        </motion.div>
      </div>

      {/* Enhanced Security Badge */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, delay: 0.8 }}
        className="inline-flex items-center space-x-3 px-6 py-3 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 backdrop-blur-md border border-cyan-400/30 rounded-2xl shadow-lg"
      >
        <Icon name="Lock" size={20} className="text-green-400" />
        <span className="text-white font-semibold text-sm">
          Sistema Seguro
        </span>
        <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
      </motion.div>

      {/* Enhanced Company Information */}
      <div className="space-y-4 text-center">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1 }}
          className="flex items-center justify-center space-x-6 text-sm text-cyan-300"
        >
          <div className="flex items-center space-x-2">
            <Icon name="MapPin" size={16} className="text-cyan-400" />
            <span>Aguascalientes, México</span>
          </div>
          <div className="w-1 h-1 bg-cyan-500 rounded-full"></div>
          <div className="flex items-center space-x-2">
            <Icon name="Clock" size={16} className="text-cyan-400" />
            <span>24/7 Operativo</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1.2 }}
          className="text-sm text-cyan-200 bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-3"
        >
          Servicio y Mantenimiento de Transporte Pesado
        </motion.div>
      </div>

      {/* Enhanced Version and Copyright */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 1.4 }}
        className="pt-6 border-t border-cyan-500/20 space-y-3"
      >
        <div className="flex items-center justify-center space-x-3 text-xs text-cyan-300">
          <div className="w-1 h-1 bg-cyan-500 rounded-full"></div>
        </div>
        <p className="text-xs text-cyan-400">
          © {currentYear} ElektronikPro
        </p>
      </motion.div>
    </motion.div>
  );
};

export default CompanyBranding;